module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_promo-8ada4703f0af11b4bdf910152d1a42e3.png";